/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListDictionaryClass } from '../models/api-response-list-dictionary-class';
import { listsByClass } from '../fn/dictionary-api/lists-by-class';
import { ListsByClass$Params } from '../fn/dictionary-api/lists-by-class';

@Injectable({ providedIn: 'root' })
export class DictionaryApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listsByClass()` */
  static readonly ListsByClassPath = '/v1/api/dictionaries/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listsByClass()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listsByClass$Response(params: ListsByClass$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListDictionaryClass>> {
    return listsByClass(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listsByClass$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listsByClass(params: ListsByClass$Params, context?: HttpContext): Observable<ApiResponseListDictionaryClass> {
    return this.listsByClass$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListDictionaryClass>): ApiResponseListDictionaryClass => r.body)
    );
  }

}
